<script>
import i18n from "../i18n";
import { sessionHelper } from '@/utils'

export default {
  computed: {
  },
  data() {
    return {
      name: sessionHelper.getUserName(),
      staffName: sessionHelper.getStaffUserName(),
      user_type: sessionHelper.getUserType(),
      user_image: sessionHelper.getStaffUserImage(),
      company_name: sessionHelper.getStaffCompanyName(),
      company_uuid: sessionHelper.getStaffCompanyUUID(),
      location_name: sessionHelper.getStaffLocationName(),
      location_uuid: sessionHelper.getStaffLocationUUID(),
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English"
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese"
        },
        {
          flag: require("@/assets/images/flags/melayu.png"),
          language: "ms",
          title: "Bahasa Melayu"
        },
      ],
      current_language: "en",
    };
  },
  created() {
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    setLanguage(locale) {
      i18n.locale = locale;
      this.current_language = i18n.locale;
    }
  }
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png" alt width="40%" />
            </span>
            <span class="logo-lg">
              <img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png" alt width="40%" />
            </span>
          </a>

          <a href="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png" alt width="40%" />
            </span>
            <span class="logo-lg">
              <img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png" alt width="40%" />
            </span>
          </a>
        </div>

        <button @click="toggleMenu" type="button" class="btn btn-sm px-3 font-size-24 header-item waves-effect"
          id="vertical-menu-btn">
          <i class="ri-menu-2-line align-middle"></i>
        </button>
      </div>

      <div class="d-flex">
        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class src="@/assets/images/flags/us.jpg" alt="Header Language" height="16" />
          </template>
          <b-dropdown-item class="notify-item" v-for="(entry, i) in languages" :key="`Lang${i}`" :value="entry"
            @click="setLanguage(entry.language)" :link-class="{ 'active': entry.language === current_language }">
            <img :src="`${entry.flag}`" alt="user-image" class="mr-1" height="12" />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <b-dropdown v-if="user_type == 'ADMIN'" right variant="black" toggle-class="header-item"
          class="d-inline-block user-dropdown">
          <template v-slot:button-content>
            <img class="rounded-circle header-profile-user"
              src="https://getbase.s3.ap-southeast-1.amazonaws.com/default_profile_image.jpg" alt="Header Avatar"
              style="margin: 5px;" />
            <span class="d-none d-xl-inline-block ml-1">{{ name }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <a class="dropdown-item" href="/profile">
            <i class="ri-user-line align-middle mr-1"></i>
            {{ $t('module.profile') }}
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="/logout">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t('module.logout') }}
          </a>
        </b-dropdown>
        <b-dropdown v-else right variant="black" toggle-class="header-item" class="d-inline-block user-dropdown">
          <template v-slot:button-content>
            <img class="rounded-circle header-profile-user" :src="user_image" alt="Header Avatar"
              style="margin: 5px;" />
            <span class="d-none d-xl-inline-block ml-1">{{ staffName }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <a class="dropdown-item" href="/staff-profile">
            <i class="ri-user-line align-middle mr-1"></i>
            {{ $t('module.profile') }}
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="/staff-logout">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t('module.logout') }}
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.notify-item {
  .active {
    color: #16181b;
    background-color: #f8f9fa;
  }
}
</style>

<style scoped>
.selected-text span {
  color: #007bff;
  /* Change text color to blue */
  font-weight: bold;
  /* Optional: make the text bold */
}
</style>